import {
  REQUEST_LOADED,
  ALL_REQUESTS_LOADED,
} from "../actions/types";

const initialState = {
  allRequests: null,
  request: null,
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REQUEST_LOADED:
      return {
        ...state,
        request: payload,
        loading: false,
      };

    case ALL_REQUESTS_LOADED:
      return {
        ...state,
        allRequests: payload,
        loading: false,
      };

    default:
      return state;
  }
}
